<div #scrollTo></div>
<app-page-header header={{headerTitle}} backgroundPath="assets/images/lead/lead-calculate.jpg"></app-page-header>

<div *ngIf="!hideStep" class="menu--wrapper">
    <app-nav-menu [menuList]="menuList" [activeMenu]="activeMenu" (selectedMenu)="onMenuChange($event)"></app-nav-menu>
</div>

<!-- <ng-container *ngIf="activeMenu==='1'">
    <app-investing-learning [disableHeader]="true"></app-investing-learning>
</ng-container> -->

<ng-container *ngIf="activeMenu==='1'">
    <app-fund-service-unit [disableHeader]="true"></app-fund-service-unit>
</ng-container>

<ng-container *ngIf="activeMenu==='2'">
    <ng-container *ngTemplateOutlet="portPlan"></ng-container>
</ng-container>

<ng-container *ngIf="activeMenu==='4'">
    <app-investing-by-risk></app-investing-by-risk>
</ng-container>

<ng-template #portPlan>
    <section *ngIf="!hideStep" class="section--feature">
        <div class="container">
            <header class="heading-topic">
                <h2 class="topic-title">
                    <span rel="border-circle">
                        <img src="assets/images/icon/etf/ic-goal@2x.png" alt="goal">
                    </span>
                    <span class="text">{{language.planinvestmentsteptopic1}}</span>
                </h2>
            </header>
            <div #formStart class="row radio--menu">
                <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 ">
                    <app-big-radio (click)="setActive('มือใหม่หัดลงทุน')" [active]="newbeeActive"
                        icon="assets/images/icon/plan/beginer-active.png"
                        title="{{language.planinvestmenttargettitle1}}"
                        description="{{language.planinvestmenttargetdesc1}}"></app-big-radio>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4  port-plan">
                    <app-big-radio (click)="setActive('เพื่อเป้าหมาย')" [active]="taxActive"
                        icon="assets/images/icon/plan/target-active.png" title="{{language.planinvestmenttargettitle2}}"
                        description="{{language.planinvestmenttargetdesc2}}"></app-big-radio>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4  port-plan">
                    <app-big-radio (click)="setActive('เพื่อเกษียณ')" [active]="chairActive"
                        icon="assets/images/icon/icon-chair@2x.png" title="{{language.planinvestmenttargettitle3}}"
                        description="{{language.planinvestmenttargetdesc3}}"></app-big-radio>
                </div>
            </div>
        </div>
    </section>

    <!-- มือใหม่หัดลงทุน -->
    <section *ngIf="newbeeActive">
        <app-investing-by-risk *ngIf="!hideNewbeeForm" [clickForm]="'มือใหม่หัดลงทุน'"
            (clickOption)='calChairForm($event)' (returnTotalScore)="setTotalScore($event)"
            (returAge)=setAgeRange($event) (completeForm)='checkCompleteForm($event)'>
        </app-investing-by-risk>
        <div class="container" *ngIf="newbeeCal">
            <section class="risk-result">
                <header class="heading-title text-center">
                    <h2 class="topic-title">
                        <span rel="border-circle">
                            <i class="icon icon-documents"></i>
                        </span>
                        <span class="text">{{language.allocation1}}</span>
                    </h2>
                </header>

                <section class="section-group risk-score">
                    <div class="score text-center">
                        <h2 class="title">{{language.allocation2}}</h2>
                        <p class="number">{{formTotalScore}}</p>
                    </div>
                    <ul class="list list-inlined list-unstyled">
                        <li>
                            <span class="group">
                                <i class="icon icon-briefcase"></i>
                                <span class="text">
                                    <em>{{language.allocation3}}</em>
                                    <span>{{investorType}}</span>
                                </span>
                            </span>
                        </li>
                        <li>
                            <span class="group">
                                <i class="icon icon-money-bag"></i>
                                <span class="text">
                                    <em>{{language.allocation4}}</em>
                                    <span>{{investment}}</span>
                                </span>
                            </span>
                        </li>
                    </ul>
                </section>

                <section class="section-group section-risk">
                    <header class="heading-title text-center">
                        <h2 class="topic-title">
                            <span rel="border-circle">
                                <i class="icon icon-risk-low-small -white"></i>
                            </span>
                            <span class="text">{{language.allocation5}}{{recommRisk}}{{language.allocation9}}</span>
                        </h2>
                        <p class="detail">{{language.allocation6}} {{ageRange}}
                            {{language.allocation7}}{{riskLevel}}
                        </p>
                    </header>
                    <div *ngIf="row" class="row gutter-40">
                        <div class="col-lg-6">
                            <section class="text-center">
                                <div style="width: 100%;">
                                    <div id="container" class="pie-chart" [chart]="donut"></div>
                                </div>
                            </section>
                            <section class="summary summary-investment">
                                <section class="group-section">
                                    <h4 class="title">
                                        {{language.fundriskdetailtitle1}}
                                        <span>*</span>
                                    </h4>

                                    <ul class="list-unstyled list-investment">
                                        <li>
                                            <span>{{riskDetail1_1}}</span>
                                            <span class="avg-percent">{{riskDetail1_1P}}</span>
                                        </li>
                                        <li>
                                            <span>{{riskDetail1_2}}</span>
                                            <span class="avg-percent">{{riskDetail1_2P}}</span>
                                        </li>
                                    </ul>
                                </section>

                                <section class="group-section">
                                    <ul class="list-unstyled list-investment">
                                        <li>
                                            <span class="h4 title">{{language.fundriskdetailtitle2}}</span>
                                            <span class="avg-percent">{{riskDetail2p}}</span>
                                        </li>
                                    </ul>
                                </section>

                                <section class="group-section">
                                    <h4 class="title">
                                        {{language.fundriskdetailtitle3}}
                                        <span>*</span>
                                    </h4>

                                    <ul class="list-unstyled list-investment">
                                        <li>
                                            <span>{{riskDetail3_1}}</span>
                                            <span class="avg-percent">{{riskDetail3_1P}}</span>
                                        </li>
                                        <li>
                                            <span>{{riskDetail3_2}}</span>
                                            <span class="avg-percent">{{riskDetail3_2P}}</span>
                                        </li>
                                    </ul>
                                </section>
                            </section>
                        </div>
                        <div class="col-lg-6">
                            <section class="summary summary-recommend">
                                <div class="info">
                                    <ul class="list-unstyled list-fund">
                                        <li *ngIf="fundList1">
                                            <span class="title-cat-0">{{language.fundriskdetailtitle4}} {{p1}}</span>
                                            <span class="text">{{language.step2t3detail4}}</span>
                                            <ul class="list-unstyled list-inline list-feature">
                                                <li *ngFor="let item of fundList1">
                                                    <a [ngClass]="whatClass(item.risklevel, item.fundTypeNameEn)"
                                                        href="fund/detail/{{item.fundid}}/{{item.currency}}"
                                                        class="btn btn-primary">{{item.fundCode}}</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li *ngIf="fundList2">
                                            <span class="title-cat-1">{{language.fundriskdetailtitle5}} {{p2}}</span>
                                            <span class="text">{{language.step2t3detail4}}</span>
                                            <ul class="list-unstyled list-inline list-feature">
                                                <li *ngFor="let item of fundList2">
                                                    <a [ngClass]="whatClass(item.risklevel, item.fundTypeNameEn)"
                                                        href="fund/detail/{{item.fundid}}/{{item.currency}}"
                                                        class="btn btn-primary">{{item.fundCode}}</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li *ngIf="fundList3">
                                            <span class="title-cat-2">{{language.fundriskdetailtitle6}} {{p3}}</span>
                                            <span class="text">{{language.step2t3detail4}}</span>
                                            <ul class="list-unstyled list-inline list-feature">
                                                <li *ngFor="let item of fundList3">
                                                    <a [ngClass]="whatClass(item.risklevel, item.fundTypeNameEn)"
                                                        href="fund/detail/{{item.fundid}}/{{item.currency}}"
                                                        class="btn btn-primary">{{item.fundCode}}</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li *ngIf="fundList4">
                                            <span class="title-cat-3">{{language.fundriskdetailtitle7}} {{p4}}</span>
                                            <span class="text">{{language.step2t3detail4}}</span>
                                            <ul class="list-unstyled list-inline list-feature">
                                                <li *ngFor="let item of fundList4">
                                                    <a [ngClass]="whatClass(item.risklevel, item.fundTypeNameEn)"
                                                        href="fund/detail/{{item.fundid}}/{{item.currency}}"
                                                        class="btn btn-primary">{{item.fundCode}}</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li *ngIf="fundList5">
                                            <span class="title-cat-4">{{language.fundriskdetailtitle8}} {{p5}}</span>
                                            <span class="text">{{language.step2t3detail4}}</span>
                                            <ul class="list-unstyled list-inline list-feature">
                                                <li *ngFor="let item of fundList5">
                                                    <a [ngClass]="whatClass(item.risklevel, item.fundTypeNameEn)"
                                                        href="fund/detail/{{item.fundid}}/{{item.currency}}"
                                                        class="btn btn-primary">{{item.fundCode}}</a>
                                                </li>
                                            </ul>
                                        </li>

                                    </ul>
                                </div>
                            </section>
                            <section class="remark">
                                <br>
                                <span class="red">*</span>
                                <span> {{language.step2remark1}}
                                </span>
                                <br>
                                <br>
                                <span class="blue">*</span>
                                <span> {{language.step2remark2}}
                                </span>
                            </section>
                        </div>
                    </div>
                    <div *ngIf="mid" class="row gutter-40">
                        <div class="col-lg-6">
                            <section class="text-center">
                                <div style="width: 100%;">
                                    <div id="container" class="pie-chart" [chart]="donut"></div>
                                </div>
                            </section>
                            <section class="summary summary-investment">
                                <section class="group-section">
                                    <h4 class="title">
                                        {{language.fundriskdetailtitle1}}
                                        <span>*</span>
                                    </h4>

                                    <ul class="list-unstyled list-investment">
                                        <li>
                                            <span>{{riskDetail1_1}}</span>
                                            <span class="avg-percent">{{riskDetail1_1P}}</span>
                                        </li>
                                        <li>
                                            <span>{{riskDetail1_2}}</span>
                                            <span class="avg-percent">{{riskDetail1_2P}}</span>
                                        </li>
                                    </ul>
                                </section>

                                <section class="group-section">
                                    <ul class="list-unstyled list-investment">
                                        <li>
                                            <span class="h4 title">{{language.fundriskdetailtitle2}}</span>
                                            <span class="avg-percent">{{riskDetail2p}}</span>
                                        </li>
                                    </ul>
                                </section>

                                <section class="group-section">
                                    <h4 class="title">
                                        {{language.fundriskdetailtitle3}}
                                        <span>*</span>
                                    </h4>

                                    <ul class="list-unstyled list-investment">
                                        <li>
                                            <span>{{riskDetail3_1}}</span>
                                            <span class="avg-percent">{{riskDetail3_1P}}</span>
                                        </li>
                                        <li>
                                            <span>{{riskDetail3_2}}</span>
                                            <span class="avg-percent">{{riskDetail3_2P}}</span>
                                        </li>
                                    </ul>
                                </section>
                            </section>
                        </div>
                        <div class="col-lg-6">
                            <section class="summary summary-recommend">
                                <div class="info">
                                    <ul class="list-unstyled list-fund">
                                        <li *ngIf="fundList1">
                                            <span class="title-cat-0">{{language.fundriskdetailtitle4}} {{p1}}</span>
                                            <span class="text">{{language.step2t3detail4}}</span>
                                            <ul class="list-unstyled list-inline list-feature">
                                                <li *ngFor="let item of fundList1">
                                                    <a [ngClass]="whatClass(item.risklevel, item.fundTypeNameEn)"
                                                        href="fund/detail/{{item.fundid}}/{{item.currency}}"
                                                        class="btn btn-primary">{{item.fundCode}}</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li *ngIf="fundList2">
                                            <span class="title-cat-1">{{language.fundriskdetailtitle5}} {{p2}}</span>
                                            <span class="text">{{language.step2t3detail4}}</span>
                                            <ul class="list-unstyled list-inline list-feature">
                                                <li *ngFor="let item of fundList2">
                                                    <a [ngClass]="whatClass(item.risklevel, item.fundTypeNameEn)"
                                                        href="fund/detail/{{item.fundid}}/{{item.currency}}"
                                                        class="btn btn-primary">{{item.fundCode}}</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li *ngIf="fundList3">
                                            <span class="title-cat-2">{{language.fundriskdetailtitle6}} {{p3}}</span>
                                            <span class="text">{{language.step2t3detail4}}</span>
                                            <ul class="list-unstyled list-inline list-feature">
                                                <li *ngFor="let item of fundList3">
                                                    <a [ngClass]="whatClass(item.risklevel, item.fundTypeNameEn)"
                                                        href="fund/detail/{{item.fundid}}/{{item.currency}}"
                                                        class="btn btn-primary">{{item.fundCode}}</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li *ngIf="fundList4">
                                            <span class="title-cat-3">{{language.fundriskdetailtitle7}} {{p4}}</span>
                                            <span class="text">{{language.step2t3detail4}}</span>
                                            <ul class="list-unstyled list-inline list-feature">
                                                <li *ngFor="let item of fundList4">
                                                    <a [ngClass]="whatClass(item.risklevel, item.fundTypeNameEn)"
                                                        href="fund/detail/{{item.fundid}}/{{item.currency}}"
                                                        class="btn btn-primary">{{item.fundCode}}</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <!-- <li>
                                            <span class="title-cat-4">กองทุนตราสารทุนต่างประเทศ
                                                {{p6}}</span>
                                            <span class="text">{{language.step2t3detail4}}</span>
                                            <ul class="list-unstyled list-inline list-feature">
                                                <li *ngFor="let item of fundList6">
                                                    <a [ngClass]="whatClass(item.risklevel, item.fundTypeNameEn)"
                                                        href="fund/detail/{{item.fundid}}/{{item.currency}}"
                                                        class="btn btn-primary">{{item.fundCode}}</a></li>
                                            </ul>
                                        </li> -->
                                        <li *ngIf="fundList5">
                                            <span class="title-cat-5">{{language.fundriskdetailtitle8}} {{p5}}</span>
                                            <span class="text">{{language.step2t3detail4}}</span>
                                            <ul class="list-unstyled list-inline list-feature">
                                                <li *ngFor="let item of fundList5">
                                                    <a [ngClass]="whatClass(item.risklevel, item.fundTypeNameEn)"
                                                        href="fund/detail/{{item.fundid}}/{{item.currency}}"
                                                        class="btn btn-primary">{{item.fundCode}}</a>
                                                </li>
                                            </ul>
                                        </li>


                                    </ul>
                                </div>
                            </section>
                            <section class="remark">
                                <br>
                                <span class="red">*</span>
                                <span> {{language.step2remark1}}
                                </span>
                                <br>
                                <br>
                                <span class="blue">*</span>
                                <span> {{language.step2remark2}}
                                </span>
                            </section>
                        </div>
                    </div>
                    <div *ngIf="high" class="row gutter-40">
                        <div class="col-lg-6">
                            <section class="text-center">
                                <div style="width: 100%;">
                                    <div id="container" class="pie-chart" [chart]="donut"></div>
                                </div>
                            </section>
                            <section class="summary summary-investment">
                                <section class="group-section">
                                    <h4 class="title">
                                        {{language.fundriskdetailtitle1}}
                                        <span>*</span>
                                    </h4>

                                    <ul class="list-unstyled list-investment">
                                        <li>
                                            <span>{{riskDetail1_1}}</span>
                                            <span class="avg-percent">{{riskDetail1_1P}}</span>
                                        </li>
                                        <li>
                                            <span>{{riskDetail1_2}}</span>
                                            <span class="avg-percent">{{riskDetail1_2P}}</span>
                                        </li>
                                    </ul>
                                </section>

                                <section class="group-section">
                                    <ul class="list-unstyled list-investment">
                                        <li>
                                            <span class="h4 title">{{language.fundriskdetailtitle2}}</span>
                                            <span class="avg-percent">{{riskDetail2p}}</span>
                                        </li>
                                    </ul>
                                </section>

                                <section class="group-section">
                                    <h4 class="title">
                                        {{language.fundriskdetailtitle3}}
                                        <span>*</span>
                                    </h4>

                                    <ul class="list-unstyled list-investment">
                                        <li>
                                            <span>{{riskDetail3_1}}</span>
                                            <span class="avg-percent">{{riskDetail3_1P}}</span>
                                        </li>
                                        <li>
                                            <span>{{riskDetail3_2}}</span>
                                            <span class="avg-percent">{{riskDetail3_2P}}</span>
                                        </li>
                                    </ul>
                                </section>
                            </section>
                        </div>
                        <div class="col-lg-6">
                            <section class="summary summary-recommend">
                                <div class="info">
                                    <ul class="list-unstyled list-fund">
                                        <li *ngIf="fundList1">
                                            <span class="title-cat-0">{{language.fundriskdetailtitle4}} {{p1}}</span>
                                            <span class="text">{{language.step2t3detail4}}</span>
                                            <ul class="list-unstyled list-inline list-feature">
                                                <li *ngFor="let item of fundList1">
                                                    <a [ngClass]="whatClass(item.risklevel, item.fundTypeNameEn)"
                                                        href="fund/detail/{{item.fundid}}/{{item.currency}}"
                                                        class="btn btn-primary">{{item.fundCode}}</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li *ngIf="fundList2">
                                            <span class="title-cat-1">{{language.fundriskdetailtitle5}} {{p2}}</span>
                                            <span class="text">{{language.step2t3detail4}}</span>
                                            <ul class="list-unstyled list-inline list-feature">
                                                <li *ngFor="let item of fundList2">
                                                    <a [ngClass]="whatClass(item.risklevel, item.fundTypeNameEn)"
                                                        href="fund/detail/{{item.fundid}}/{{item.currency}}"
                                                        class="btn btn-primary">{{item.fundCode}}</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li *ngIf="fundList3">
                                            <span class="title-cat-2">{{language.fundriskdetailtitle6}} {{p3}}</span>
                                            <span class="text">{{language.step2t3detail4}}</span>
                                            <ul class="list-unstyled list-inline list-feature">
                                                <li *ngFor="let item of fundList3">
                                                    <a [ngClass]="whatClass(item.risklevel, item.fundTypeNameEn)"
                                                        href="fund/detail/{{item.fundid}}/{{item.currency}}"
                                                        class="btn btn-primary">{{item.fundCode}}</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li *ngIf="fundList4">
                                            <span class="title-cat-3">{{language.fundriskdetailtitle7}} {{p4}}</span>
                                            <span class="text">{{language.step2t3detail4}}</span>
                                            <ul class="list-unstyled list-inline list-feature">
                                                <li *ngFor="let item of fundList4">
                                                    <a [ngClass]="whatClass(item.risklevel, item.fundTypeNameEn)"
                                                        href="fund/detail/{{item.fundid}}/{{item.currency}}"
                                                        class="btn btn-primary">{{item.fundCode}}</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <!-- <li>
                                            <span class="title-cat-4">กองทุนตราสารทุนต่างประเทศ
                                                {{p6}}</span>
                                            <span class="text">{{language.step2t3detail4}}</span>
                                            <ul class="list-unstyled list-inline list-feature">
                                                <li *ngFor="let item of fundList6">
                                                    <a [ngClass]="whatClass(item.risklevel, item.fundTypeNameEn)"
                                                        href="fund/detail/{{item.fundid}}/{{item.currency}}"
                                                        class="btn btn-primary">{{item.fundCode}}</a></li>
                                            </ul>
                                        </li> -->
                                        <li *ngIf="fundList5">
                                            <span class="title-cat-5">{{language.fundriskdetailtitle8}} {{p5}}</span>
                                            <span class="text">{{language.step2t3detail4}}</span>
                                            <ul class="list-unstyled list-inline list-feature">
                                                <li *ngFor="let item of fundList5">
                                                    <a [ngClass]="whatClass(item.risklevel, item.fundTypeNameEn)"
                                                        href="fund/detail/{{item.fundid}}/{{item.currency}}"
                                                        class="btn btn-primary">{{item.fundCode}}</a>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </section>
                            <section class="remark">
                                <br>
                                <span class="red">*</span>
                                <span> {{language.step2remark1}}
                                </span>
                                <br>
                                <br>
                                <span class="blue">*</span>
                                <span> {{language.step2remark2}}
                                </span>
                            </section>
                        </div>
                    </div>
                </section>

                <section class="section-terms">
                    <section class="block-scroll">
                        <section class="wrapper" tabindex="2" style="overflow-y: auto; outline: none;">

                            <div class="group-section">
                                <h3 class="topic-title sub-title h6 star">Assumption</h3>
                                <p>{{language.assumptiontitle}}</p>

                                <ol>
                                    <li>{{language.assumptiondetail1}}</li>
                                    <li>{{language.assumptiondetail2}}
                                    </li>
                                    <li>{{language.assumptiondetail3}}</li>
                                    <li>{{language.assumptiondetail4}}
                                    </li>
                                    <li>{{language.assumptiondetail5}}</li>
                                    <li>{{language.assumptiondetail6}}
                                    </li>
                                </ol>
                            </div>

                        </section>
                    </section>
                </section>
            </section>

            <footer class="text-center">
                <a (click)="newbeeFormAgain()" class="btn btn-primary -brand">{{language.allocation8}}</a>
            </footer>
        </div>

    </section>

    <!-- เพื่อเป้าหมาย -->
    <section *ngIf="taxActive" id="tax-break" class="section-list-plan">
        <app-investing-by-risk *ngIf="!hideTaxForm" [clickForm]="'เพื่อเป้าหมาย'" (clickOption)='calChairForm($event)'
            (returnTotalScore)="setTotalScore($event)" (completeForm)='checkCompleteForm($event)'>
        </app-investing-by-risk>
        <section *ngIf="taxCal">
            <section class="section--saving">
                <div class="container">
                    <header class="heading-topic">
                        <h2 class="topic-title">
                            <span rel="border-circle">
                                <img src="assets/images/icon/step/ic-piggybank@2x.png" alt="goal">
                            </span>
                            <span class="text">{{language.allocation26}}</span>
                        </h2>
                    </header>
                    <div class="row">
                        <div *ngIf="flag == 'th'" class="col-md-12 offset-lg-6 col-lg-6 ">
                            <div class="form--item form-group form-inline">
                                <div class="label--wrapper first col-md-4 col-lg-3">{{language.allocation27}}</div>
                                <div class="input--wrapper col-md-8 col-lg-9">
                                    <app-input [value]="0" [alignRight]="true" [name]="'targetSaving'"
                                        (fieldValue)="setGoalMoney($event)">
                                    </app-input>
                                    <span>{{language.allocation28}}</span>
                                </div>
                                <div *ngIf="timeHorizonRequire"
                                    class="error-message offset-md-4 col-md-8 offset-lg-3 col-lg-9">
                                    {{language.allocation29}}</div>
                            </div>
                            <div class="form--item form-group form-inline">
                                <div class="label--wrapper first col-md-4 col-lg-3">{{language.allocation30}}</div>
                                <div class="input--wrapper col-md-8 col-lg-9">
                                    <app-input [value]="0" [alignRight]="true" [name]="'currentSaving'"
                                        (fieldValue)="setSafeMoney($event)">
                                    </app-input>
                                    <span>{{language.allocation28}}</span>
                                </div>
                            </div>
                            <div class="form--item form-group form-inline">
                                <div class="label--wrapper second col-md-4 col-lg-3">{{language.allocation31}}</div>
                                <div class="input--wrapper col-md-8 col-lg-9">
                                    <app-input [value]="0" [alignRight]="true" [name]="'investmentTime'"
                                        (fieldValue)="setTimeHorizon($event)">
                                    </app-input>
                                    <span>{{language.allocation32}}</span>
                                </div>
                                <div *ngIf="timeHorizonRequire"
                                    class="error-message offset-md-4 col-md-8 offset-lg-3 col-lg-9">
                                    {{language.allocation33}}</div>
                            </div>
                        </div>
                        <div *ngIf="flag == 'en'" class="col-md-12 offset-lg-5 col-lg-7 ">
                            <div class="form--item form-group form-inline">
                                <div class="label--wrapper first col-md-5 col-lg-4">{{language.allocation27}}</div>
                                <div class="input--wrapper col-md-7 col-lg-8">
                                    <app-input [value]="0" [alignRight]="true" [name]="'targetSaving'"
                                        (fieldValue)="setGoalMoney($event)">
                                    </app-input>
                                    <span>{{language.allocation28}}</span>
                                </div>
                                <div *ngIf="timeHorizonRequire"
                                    class="error-message offset-md-5 col-md-7 offset-lg-4 col-lg-8">
                                    {{language.allocation29}}</div>
                            </div>
                            <div class="form--item form-group form-inline">
                                <div class="label--wrapper first col-md-5 col-lg-4">{{language.allocation30}}</div>
                                <div class="input--wrapper col-md-7 col-lg-8">
                                    <app-input [value]="0" [alignRight]="true" [name]="'currentSaving'"
                                        (fieldValue)="setSafeMoney($event)">
                                    </app-input>
                                    <span>{{language.allocation28}}</span>
                                </div>
                            </div>
                            <div class="form--item form-group form-inline">
                                <div class="label--wrapper second col-md-5 col-lg-4">{{language.allocation31}}</div>
                                <div class="input--wrapper col-md-7 col-lg-8">
                                    <app-input [value]="0" [alignRight]="true" [name]="'investmentTime'"
                                        (fieldValue)="setTimeHorizon($event)">
                                    </app-input>
                                    <span>{{language.allocation32}}</span>
                                </div>
                                <div *ngIf="timeHorizonRequire"
                                    class="error-message offset-md-5 col-md-7 offset-lg-4 col-lg-8">
                                    {{language.allocation33}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="section--slider">
                <div class="container">
                    <header class="heading-topic">
                        <h2 class="topic-title">
                            <span rel="border-circle">
                                <img src="assets/images/icon/step/ic-warning@2x.png" alt="goal">
                            </span>
                            <span class="text">{{language.allocation34}}</span>
                        </h2>
                    </header>
                    <div class="slider--wrapper">
                        <p>{{language.allocation35}}</p>
                        <app-radio-slider [fixLevel]="userRisk"></app-radio-slider>
                        <div class="button--wrapper">
                            <app-button (click)="calculateGenaral()" text="{{language.btn5}}" size="lg"></app-button>
                        </div>
                    </div>
                </div>
            </section>
        </section>
    </section>

    <!-- เพื่อเกษียณ -->
    <section *ngIf="chairActive">
        <app-investing-by-risk *ngIf="!hideChairForm" [clickForm]="'เพื่อเกษียณ'"
            (completeForm)='checkCompleteForm($event)' (returnTotalScore)="setTotalScore($event)"
            (clickOption)='calChairForm($event)'>
        </app-investing-by-risk>

        <section *ngIf="chairCal">
            <section class="section--saving">
                <div class="container">
                    <header class="heading-topic">
                        <h2 class="topic-title">
                            <span rel="border-circle">
                                <img src="assets/images/icon/step/ic-piggybank@2x.png" alt="goal">
                            </span>
                            <span class="text">{{language.allocation36}}</span>
                        </h2>
                    </header>
                    <div class="row">

                        <div class="col-md-12 offset-lg-5 col-lg-7">
                            <div class="form--item form-group form-inline">
                                <div class="label--wrapper first col-md-4 col-lg-3">{{language.allocation37}}</div>

                                <div class="input--wrapper col-md-8 col-lg-9">
                                    <app-input [alignRight]="true" (fieldValue)="setAgeNow($event)"
                                        [name]="'currentAge'" [isRequire]="currentAgeRequire">
                                    </app-input>
                                    <span>{{language.allocation38}}</span>
                                </div>

                                <div *ngIf="currentAgeRequire"
                                    class="error-message offset-md-4 col-md-8  offset-lg-3 col-lg-9">
                                    {{language.allocation39}}</div>

                            </div>
                            <div class="form--item form-group form-inline">
                                <div class="label--wrapper first col-md-4 col-lg-3">{{language.allocation40}}</div>
                                <div class="input--wrapper col-md-8 col-lg-9">
                                    <app-input [value]="0" [alignRight]="true" [name]="'currentSaving'"
                                        (fieldValue)="setSafeMoney($event)">
                                    </app-input>
                                    <span>{{language.allocation41}}</span>
                                </div>
                            </div>
                            <div class="form--item form-group form-inline">
                                <div class="label--wrapper second col-md-4 col-lg-3">{{language.allocation42}}</div>
                                <div class="input--wrapper col-md-8 col-lg-9">
                                    <app-input [alignRight]="true" (fieldValue)="setRetireAge($event)"
                                        [name]="'retireAge'"></app-input>
                                    <span>{{language.allocation38}}</span>
                                </div>
                                <div *ngIf="retirementAgeRequire"
                                    class="error-message offset-md-4 col-md-8  offset-lg-3 col-lg-9">
                                    {{language.allocation43}}
                                </div>

                            </div>
                            <div class="form--item form-group form-inline">
                                <div class="label--wrapper third col-md-4 col-lg-3">{{language.allocation44}}</div>
                                <div class="input--wrapper col-md-8 col-lg-9">
                                    <app-input [alignRight]="true" (fieldValue)="setMaxAge($event)" [name]="'lifeSpan'"
                                        [isRequire]="lifeSpanRequire">
                                    </app-input>
                                    <span>{{language.allocation38}}</span>
                                </div>
                                <div *ngIf="lifeSpanRequire"
                                    class="error-message offset-md-4 col-md-8  offset-lg-3 col-lg-9">
                                    {{language.allocation45}}</div>
                            </div>
                            <div class="form--item form-group form-inline">
                                <div class="label--wrapper forth col-md-4 col-lg-3">{{language.allocation46}}</div>
                                <div class="input--wrapper col-md-8 col-lg-9">
                                    <app-input [value]="0" [alignRight]="true" (fieldValue)="setPayAfterRetire($event)"
                                        [name]="'retirePayment'" [isRequire]="retirementPayRequire">
                                    </app-input>
                                    <span>{{language.allocation47}}</span>
                                </div>
                                <div *ngIf="retirementPayRequire"
                                    class="error-message offset-md-4 col-md-8  offset-lg-3 col-lg-9">
                                    {{language.allocation48}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="section--slider">
                <div class="container">
                    <header class="heading-topic">
                        <h2 class="topic-title">
                            <span rel="border-circle">
                                <img src="assets/images/icon/step/ic-warning@2x.png" alt="goal">
                            </span>
                            <span class="text">{{language.allocation49}}</span>
                        </h2>
                    </header>
                    <div class="slider--wrapper">
                        <p>{{language.allocation50}}</p>
                        <app-radio-slider [fixLevel]="userRisk"></app-radio-slider>
                        <div class="button--wrapper">
                            <app-button (click)="calculateChair()" text="{{language.btn5}}" size="lg"></app-button>
                        </div>
                    </div>
                </div>
            </section>
        </section>
    </section>

</ng-template>